/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/no-unescaped-entities */
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import styled, { css } from 'styled-components';

import AIClipProducerResults from '../../ClipProducer/AIClipProducerResults';
import ClipDurationButtonList from '../../ClipProducer/ClipDurationButtonList';
import AudienceFilterComponent from '../../common/AudienceFilterComponent';
import GoalFilterComponent from '../../common/GoalFilterComponent';
import { ProduceIcon } from '../../common/icons';
import Modal from '../../common/Modal';
import SpeakerFilterComponent from '../../common/SpeakerFilterComponent';
import SpinningLoading from '../../SpinningLoading';

import type { ClipProducerUIProps } from '../../ClipProducer/AIClipProducer';

function ClipProducerModalUI(
  props: ClipProducerUIProps & { closeModal: () => void },
) {
  const {
    supportedPresets,
    isProducing,
    retryCount,
    selectedDuration,
    setSelectedDuration,
    selectedPresets,
    onPresetClick,
    customPresetText,
    setCustomPresetText,
    selectedSocials,
    setSelectedSocials,
    producedClips,
    showModal,
    isProducingDisable,
    onProduceButtonClick,
    closeProducingModal,
    // Suggested topics props
    suggestedThemes,
    selectedSuggestedTheme,
    onSuggestedThemeClick,
    // New speaker selection props
    speakers,
    selectedSpeakers,
    setSelectedSpeakers,
    useSpeakerFilter,
    setUseSpeakerFilter,
    isLoadingSpeakers,
    showSpeakerSelector,
    // Goal selection props
    selectedGoal,
    setSelectedGoal,
    useGoalFilter,
    setUseGoalFilter,
    // Audience selection props
    selectedAudiences,
    setSelectedAudiences,
    useAudienceFilter,
    setUseAudienceFilter,
  } = props;

  const videoCreator = useVideoCreatorStore();
  const goals = videoCreator.organization?.branding?.goals || [];
  const audiences = videoCreator.organization?.branding?.audiences || [];

  const stopProducingAndClose = () => {
    closeProducingModal();
    props.closeModal();
  };

  return (
    <>
      <Modal isOpen closeModal={stopProducingAndClose}>
        <Wrapper>
          <Content>
            {isProducing && (
              <div style={{ color: '#17c964' }}>
                <SpinningLoading
                  Ico={<ProduceIcon width="24" height="24" />}
                  text={`Generating clips${
                    retryCount > 0 ? `. Retrying (${retryCount})` : ''
                  }`}
                />
              </div>
            )}
            <TopHeading>Let's produce some clips</TopHeading>

            <PresetsList>
              <Leading>Find social clips based on theme</Leading>
              <div className="options-list">
                {supportedPresets.map(preset => (
                  <PresetOption
                    key={preset.title}
                    active={selectedPresets.includes(preset.title)}
                    onClick={() => onPresetClick(preset.title)}
                  >
                    {preset.title}
                  </PresetOption>
                ))}
              </div>
              <div className="input">
                <label htmlFor="customPresetInput">Customize</label>
                <PresentTextArea
                  id="customPresetInput"
                  placeholder="Type in what you'd like to see"
                  value={customPresetText}
                  onChange={e => {
                    setCustomPresetText(e.target.value);
                  }}
                />
              </div>
            </PresetsList>

            {suggestedThemes?.length > 0 && (
              <PresetsList>
                <Leading>Suggested topics</Leading>
                <div className="options-list">
                  {suggestedThemes.map(title => (
                    <PresetOption
                      key={title}
                      active={selectedSuggestedTheme === title}
                      onClick={() => onSuggestedThemeClick(title)}
                    >
                      {title}
                    </PresetOption>
                  ))}
                </div>
              </PresetsList>
            )}

            <FilterSection>
              <DurationFilter>
                <Leading>
                  Choose your desired approximate length in seconds
                </Leading>
                <ClipDurationButtonList
                  setSelectedDuration={setSelectedDuration}
                  selectedDuration={selectedDuration}
                />
              </DurationFilter>
            </FilterSection>

            {/* Goal selection */}
            {goals.length > 0 && (
              <FilterSection>
                <GoalFilterComponent
                  align="left"
                  goals={goals}
                  selectedGoal={selectedGoal}
                  setSelectedGoal={setSelectedGoal}
                  useGoalFilter={useGoalFilter}
                  setUseGoalFilter={setUseGoalFilter}
                  allowNone
                />
              </FilterSection>
            )}

            {/* Audience selection */}
            {audiences.length > 0 && (
              <FilterSection>
                <AudienceFilterComponent
                  align="left"
                  audiences={audiences}
                  selectedAudiences={selectedAudiences}
                  setSelectedAudiences={setSelectedAudiences}
                  useAudienceFilter={useAudienceFilter}
                  setUseAudienceFilter={setUseAudienceFilter}
                />
              </FilterSection>
            )}

            {/* Speaker selection UI - only show if enabled */}
            {showSpeakerSelector && (
              <FilterSection>
                <SpeakerFilterComponent
                  align="left"
                  speakers={speakers}
                  selectedSpeakers={selectedSpeakers}
                  setSelectedSpeakers={setSelectedSpeakers}
                  useSpeakerFilter={useSpeakerFilter}
                  setUseSpeakerFilter={val =>
                    setUseSpeakerFilter(
                      typeof val === 'function' ? val(useSpeakerFilter) : val,
                    )
                  }
                  isLoadingSpeakers={isLoadingSpeakers}
                  title="Filter clips by speaker"
                />
              </FilterSection>
            )}

            <ProduceButton
              onClick={onProduceButtonClick}
              disabled={isProducingDisable}
            >
              <ProduceIcon /> Produce
            </ProduceButton>
          </Content>
        </Wrapper>
      </Modal>
      {showModal && Boolean(producedClips?.length) && (
        <Modal isOpen closeModal={stopProducingAndClose}>
          <AIClipProducerResults
            hidePlatformName
            sourcePlatform="content-studio"
            onClose={stopProducingAndClose}
            fragments={producedClips!}
            isProducing={isProducing}
          />
        </Modal>
      )}
    </>
  );
}

export default ClipProducerModalUI;

const Wrapper = styled.div`
  border-radius: 10px;
  background-color: #03041a;
  width: 100%;
  max-width: 942px;
  min-width: 825px;
  border: 1px solid #484848;
  max-height: 80vh;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
`;

const Content = styled.div`
  max-width: 480px;
  margin: 0 auto;
  display: grid;
  place-items: center;
  background-color: #03041a;
  gap: 10px;
  padding: 50px 0;
`;

const TopHeading = styled.h2`
  font-weight: 700;
  font-size: 32px;
  line-height: 38.73px;
  text-align: center;
  color: #f3e9d7;
  margin: 0;
`;

const Leading = styled.div<{ color?: string }>`
  width: 100%;
  color: ${props => props.color ?? '#f3e9d7'};
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  text-align: center;
`;

const PresentTextArea = styled.textarea`
  box-sizing: border-box;
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid #5d5d5d;
  font-family: 'Inter', sans-serif;
  text-align: left;
  font-size: 10px;
  line-height: 150%;
  background-color: transparent;
  color: #f3e9d7;
  width: 100%;
  resize: none;
  height: 70px;
  outline: none;
  &::placeholder {
    color: #949494;
  }
`;

const DurationFilter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;
`;

const FilterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 16px;
  margin-bottom: 8px;
  border-bottom: 1px solid #484848;

  &:last-of-type {
    border-bottom: none;
  }
`;

const ProduceButton = styled.div.attrs((props: { disabled: boolean }) => props)`
  width: 240px;
  display: flex;
  height: 48px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: #17c964;
  box-sizing: border-box;

  color: #03041a;
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;

  ${props =>
    props.disabled &&
    `
    cursor: not-allowed;
    color: #030419;
    opacity: 0.6;
  `}
`;

const PresetsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;

  .options-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    flex: 1;
    gap: 8px;
  }

  .input {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    label {
      font-size: 10px;
      color: #f3e9d7;
    }
  }
  gap: 10px;
`;

const PresetOption = styled.div.attrs((props: { active: boolean }) => props)`
  padding: 8px;
  position: relative;
  border-radius: 8px;
  width: calc(50% - 4px);
  box-sizing: border-box;
  border: 1px solid #5d5d5d;
  cursor: pointer;
  color: #9b9b9b;
  font-size: 10px;
  font-weight: 500;
  line-height: 150%;
  transition: 150ms;

  ${props =>
    props.active &&
    css`
      color: #03041a;
      border-color: #f2d093;
      background-color: #f2d093;
    `}

  ${props =>
    !props.active &&
    css`
      &:hover {
        color: #f2d093;
      }
    `}

  &::after {
    content: '';
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 14px;
    border: 1px solid #848484;
    right: 8px;
    top: 0;
    bottom: 0;
    margin: auto;
    ${props =>
      props.active &&
      `
      font-size: 9px;
      font-weight: 600;
      text-align: center;
      content: '✓';
      color: #4ad067;
      background: #030419;
    `}
  }
`;
